module.exports = __webpack_public_path__ + "static/media/stage_4.67a73406.png";